import { ArrowRight, Building2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { FRONTEND_ROUTES } from "@fysaro/shared";
import { useAppHref } from "@/utils/appUrl";

export function ForClinicsCTA() {
  const { t } = useTranslation(["landing"]);
  const registerHref = useAppHref(FRONTEND_ROUTES.auth.registerClinic);

  return (
    <section className="bg-primary/30 border-y border-primary/10 py-16 px-6">
      <div className="max-w-4xl mx-auto text-center space-y-6">
        <div className="inline-flex p-3 rounded-full bg-primary/10 text-primary mx-auto">
          <Building2 size={28} />
        </div>
        <h2 className="text-2xl md:text-3xl font-black tracking-tight text-foreground">
          {t("landing:for_clinics.title")}
        </h2>
        <p className="text-muted-foreground text-sm max-w-xl mx-auto font-medium">
          {t("landing:for_clinics.sub_title")}
        </p>
        <div className="pt-2">
          <a
            href={registerHref}
            className="inline-flex items-center gap-2 bg-foreground text-background px-6 py-3 rounded-xl font-bold text-xs uppercase tracking-wider hover:opacity-90 transition group shadow-md"
          >
            {t("landing:for_clinics.main_action")}
            <ArrowRight
              size={14}
              className="group-hover:translate-x-1 transition-transform"
            />
          </a>
        </div>
      </div>
    </section>
  );
}
